// @flow
import { combineReducers } from 'redux';

import * as types from '../types/trips';
import * as common from './common';
import type { TRIP_STOP_TYPE } from '../types/trips';


export type TripStopsState = {
  byId: {[number]: TRIP_STOP_TYPE}
};

const byId = common.byId({
  fetched: [types.TRIP_STOPS_FETCH_SUCCEED],
  added: [types.TRIP_STOP_ADDED],
  removed: [types.TRIP_STOP_REMOVED],
  updated: [
    types.TRIP_STOP_UPDATED,
    types.TRIP_STOP_COMPLETED,
  ],
  cascade: {
    [types.TRIP_REMOVED]: 'trip',
  },
});

const tripStops = combineReducers({
  byId,
});

export default tripStops;

export const getTripStops = (state: TripStopsState): Array<TRIP_STOP_TYPE> => Object.values(state.byId);
export const getTripStop = (state: TripStopsState, id: number): TRIP_STOP_TYPE => state.byId[id];
export const isTripStopCompleted = (
  state: TripStopsState,
  id: number,
): boolean => state.byId[id].is_completed;
export const getTripStopStudentIds = (
  state: TripStopsState,
  id: number,
): Array<number> => state.byId[id].students;
export const getTripStopPathToNextStop = (
  state: TripStopsState,
  id: number,
) => getTripStop(state, id).path_to_next_stop || [];



// WEBPACK FOOTER //
// ./src/scripts/reducers/tripStops.js